export const APP_COMMANDS = [
  {
    id: "new-note",
    key: "NEW",
    label: "New note",
    detail: "Create a note",
    shortcut: "⌘⇧E",
    keywords: ["create", "add", "entry"],
  },
  {
    id: "daily-note",
    key: "DAY",
    label: "Daily note",
    detail: "Open today's note in daily/",
    shortcut: "",
    keywords: ["today", "journal", "diary", "date", "create"],
  },
  {
    id: "scratch-note",
    key: "SCR",
    label: "Scratch note",
    detail: "Start a new note in scratch/",
    shortcut: "",
    keywords: ["quick", "jot", "temporary", "draft", "pad", "create"],
  },
  {
    id: "journal-note",
    key: "JRNL",
    label: "Journal note",
    detail: "Start a new entry in journal/",
    shortcut: "",
    keywords: ["diary", "entry", "log", "date", "create"],
  },
  {
    id: "find-note",
    key: "FIND",
    label: "Find or switch note",
    detail: "Open Library Index",
    shortcut: "⌘K",
    keywords: ["search", "open", "library", "switch"],
  },
  {
    id: "open-note",
    key: "OPEN",
    label: "Open note…",
    detail: "Browse the folder tree",
    shortcut: "",
    keywords: ["file", "directory", "tree"],
  },
  {
    id: "new-folder",
    key: "DIR",
    label: "New folder…",
    detail: "Create and checkpoint a folder",
    shortcut: "",
    keywords: ["directory", "create"],
  },
  {
    id: "edit-folder",
    key: "DIR",
    label: "Edit folder…",
    detail: "Rename, move, delete, or pick its icon",
    shortcut: "",
    keywords: ["directory", "rename", "move", "delete", "remove", "icon", "emoji", "picture"],
  },
  {
    id: "new-encrypted-folder",
    key: "SEAL",
    label: "New encrypted folder…",
    detail: "Create a folder locked with a passphrase",
    shortcut: "",
    keywords: ["directory", "create", "encrypt", "age", "private", "secret", "password"],
  },
  {
    id: "lock-folders",
    key: "LOCK",
    label: "Lock encrypted folders",
    detail: "Forget every unlocked folder key now",
    shortcut: "",
    keywords: ["encrypt", "age", "private", "secret", "password", "security"],
  },
  {
    id: "clear-mentions",
    key: "@",
    label: "Clear @mentions",
    detail: "Forget the people offered after @",
    shortcut: "",
    keywords: ["mention", "people", "person", "tag", "autocomplete", "cache", "forget", "reset"],
  },
  {
    id: "save-note",
    key: "SAVE",
    label: "Save note",
    detail: "Checkpoint the current note to GitHub",
    shortcut: "",
    keywords: ["file", "commit"],
  },
  {
    id: "save-all",
    key: "ALL",
    label: "Save all",
    detail: "Checkpoint every local change to GitHub",
    shortcut: "",
    keywords: ["files", "commit"],
  },
  {
    id: "checkpoint",
    key: "SAVE",
    label: "Create checkpoint",
    detail: "Commit all pending vault changes",
    shortcut: "",
    keywords: ["revision", "snapshot", "time machine"],
  },
  {
    id: "edit-note",
    key: "EDIT",
    label: "Edit note details",
    detail: "Title, folder and pinning",
    shortcut: "",
    keywords: ["settings", "rename", "folder", "pin"],
  },
  {
    id: "move-note",
    key: "MOVE",
    label: "Move note…",
    detail: "Pick the folder it goes to",
    shortcut: "",
    keywords: ["folder", "relocate", "file"],
  },
  {
    id: "export-note",
    key: "OUT",
    label: "Export Markdown…",
    detail: "Download the open note",
    shortcut: "",
    keywords: ["file", "download", "backup", "md"],
  },
  {
    id: "copy-markdown",
    key: "COPY",
    label: "Copy Markdown",
    detail: "Copy the open note",
    shortcut: "",
    keywords: ["clipboard", "text", "source"],
  },
  {
    id: "delete-note",
    key: "DEL",
    label: "Delete note…",
    detail: "Delete with local recovery",
    shortcut: "",
    keywords: ["remove", "erase", "destroy"],
  },
  {
    id: "toggle-preview",
    key: "MODE",
    label: "Toggle Live Preview",
    detail: "Switch editor mode",
    shortcut: "F4",
    keywords: ["source", "markdown", "editor", "view"],
  },
  {
    id: "toggle-preview-mode",
    key: "READ",
    label: "Toggle Preview mode",
    detail: "Read this pane's note without editing it",
    shortcut: "F3",
    keywords: ["read-only", "readonly", "reading", "uneditable", "rendered", "view"],
  },
  {
    id: "format-bold",
    key: "B",
    label: "Format selection: Bold",
    detail: "Wrap with **",
    shortcut: "⌘B",
    keywords: ["strong", "markdown", "text"],
  },
  {
    id: "format-italic",
    key: "I",
    label: "Format selection: Italic",
    detail: "Wrap with _",
    shortcut: "⌘I",
    keywords: ["emphasis", "markdown", "text"],
  },
  {
    id: "format-link",
    key: "LINK",
    label: "Format selection: Link",
    detail: "Add Markdown link",
    shortcut: "⌘⇧K",
    keywords: ["url", "href", "markdown"],
  },
  {
    id: "format-code",
    key: "CODE",
    label: "Format selection: Inline code",
    detail: "Wrap with backticks",
    shortcut: "",
    keywords: ["monospace", "markdown", "text"],
  },
  {
    id: "insert-table",
    key: "TABLE",
    label: "Insert table",
    detail: "Add a Markdown table",
    shortcut: "",
    keywords: ["grid", "columns", "rows", "markdown"],
  },
  {
    id: "insert-image",
    key: "IMG",
    label: "Insert image…",
    detail: "Add a picture from a web address",
    shortcut: "",
    keywords: ["picture", "photo", "url", "link", "markdown"],
  },
  {
    id: "insert-figlet",
    key: "FIG",
    label: "Insert FIGlet text…",
    detail: "Big lettering drawn in characters, in one of six fonts",
    shortcut: "",
    keywords: ["ascii", "art", "banner", "figlet", "font", "letters", "title", "heading", "fun"],
  },
  {
    id: "format-document",
    key: "FMT",
    label: "Format document",
    detail: "Clean up indentation, spacing, lists, and tables",
    shortcut: "",
    keywords: ["markdown", "clean", "tidy", "whitespace", "indent", "prettify", "beautify", "lint", "note"],
  },
  {
    id: "ask-ai",
    key: "AI",
    label: "Ask AI…",
    detail: "Rewrite the selection or note, or write",
    shortcut: "",
    keywords: ["assistant", "rewrite", "edit", "fix", "improve", "write", "generate", "draft", "llm", "gpt", "claude", "prompt", "selection"],
  },
  {
    id: "format-table-selection",
    key: "TABLE",
    label: "Format tables in selection",
    detail: "Align the selected Markdown table columns",
    shortcut: "",
    keywords: ["table", "align", "columns", "source"],
  },
  {
    id: "format-table-document",
    key: "TABLE",
    label: "Format all tables",
    detail: "Align every Markdown table in this note",
    shortcut: "",
    keywords: ["table", "align", "columns", "source", "document"],
  },
  {
    id: "copy-table",
    key: "TABLE",
    label: "Copy table",
    detail: "Copy the table at the cursor",
    shortcut: "",
    keywords: ["table", "clipboard", "grid", "markdown"],
  },
  {
    id: "format-heading-1",
    key: "H1",
    label: "Format lines: Heading 1",
    detail: "Apply # heading",
    shortcut: "",
    keywords: ["title", "header", "markdown"],
  },
  {
    id: "format-heading-2",
    key: "H2",
    label: "Format lines: Heading 2",
    detail: "Apply ## heading",
    shortcut: "",
    keywords: ["section", "header", "markdown"],
  },
  {
    id: "format-heading-3",
    key: "H3",
    label: "Format lines: Heading 3",
    detail: "Apply ### heading",
    shortcut: "",
    keywords: ["section", "header", "markdown"],
  },
  {
    id: "format-bullet-list",
    key: "LIST",
    label: "Format lines: Bullet list",
    detail: "Apply - markers",
    shortcut: "",
    keywords: ["unordered", "items", "markdown"],
  },
  {
    id: "format-numbered-list",
    key: "1.",
    label: "Format lines: Numbered list",
    detail: "Number selected lines",
    shortcut: "",
    keywords: ["ordered", "items", "markdown"],
  },
  {
    id: "format-task-list",
    key: "[ ]",
    label: "Format lines: Task list",
    detail: "Add checkboxes",
    shortcut: "",
    keywords: ["todo", "checklist", "items", "markdown"],
  },
  {
    id: "format-quote",
    key: ">",
    label: "Format lines: Quote",
    detail: "Apply blockquote",
    shortcut: "",
    keywords: ["blockquote", "markdown", "text"],
  },
  {
    id: "toggle-split",
    key: "SPLIT",
    label: "Toggle split view",
    detail: "Open a second pane or close the active pane",
    shortcut: "⌘⇧Enter",
    keywords: ["editor", "panes", "view", "close"],
  },
  // Which way is "horizontal" depends on the editor you came from, so both splits answer to both words.
  {
    id: "split-right",
    key: "RIGHT",
    label: "Split pane right",
    detail: "Open a pane beside this one, up to three across",
    shortcut: "",
    keywords: ["split", "vertical", "vertically", "horizontal", "horizontally", "side by side", "columns", "grid", "editor", "panes", "view"],
  },
  {
    id: "split-down",
    key: "DOWN",
    label: "Split pane down",
    detail: "Open a pane below this one, up to three high",
    shortcut: "",
    keywords: ["split", "horizontal", "horizontally", "vertical", "vertically", "stack", "rows", "grid", "editor", "panes", "view"],
  },
  {
    id: "toggle-line-numbers",
    key: "LINE",
    label: "Toggle line numbers",
    detail: "Show or hide gutter",
    shortcut: "F2",
    keywords: ["editor", "gutter", "view"],
  },
  {
    id: "toggle-word-wrap",
    key: "WRAP",
    label: "Toggle word wrap",
    detail: "Wrap long lines or scroll sideways",
    shortcut: "",
    keywords: ["editor", "lines", "soft wrap", "horizontal", "scroll", "view"],
  },
  {
    id: "toggle-spell-check",
    key: "ABC",
    label: "Toggle spell check",
    detail: "Underline misspelled words, with suggestions on right-click",
    shortcut: "",
    keywords: ["spelling", "spellcheck", "dictionary", "typo", "proofread", "words", "view"],
  },
  {
    id: "toggle-sidebar",
    key: "SIDE",
    label: "Toggle left sidebar",
    detail: "Show or hide the widgets",
    shortcut: "",
    keywords: ["library", "notes", "index", "panel", "view"],
  },
  {
    id: "toggle-outline",
    key: "LIST",
    label: "Toggle outline",
    detail: "Headings of this note",
    shortcut: "",
    keywords: ["widget", "heading", "contents", "jump", "view"],
  },
  {
    id: "toggle-timer",
    key: "TIME",
    label: "Toggle timer",
    detail: "Count down in the sidebar",
    shortcut: "",
    keywords: ["widget", "pomodoro", "clock", "minutes", "view"],
  },
  {
    id: "toggle-calendar",
    key: "CAL",
    label: "Toggle calendar",
    detail: "Pick a day in the sidebar",
    shortcut: "",
    keywords: ["widget", "month", "date", "day", "journal", "view"],
  },
  {
    id: "toggle-calculator",
    key: "SUM",
    label: "Toggle calculator",
    detail: "Work out an expression",
    shortcut: "",
    keywords: ["widget", "math", "arithmetic", "sum", "view"],
  },
  {
    id: "toggle-revisions",
    key: "TIME",
    label: "Toggle Time Machine",
    detail: "Show revision history",
    shortcut: "",
    keywords: ["checkpoint", "history", "revisions", "sidebar"],
  },
  {
    id: "typography",
    key: "TYPE",
    label: "Markdown typography",
    detail: "Font and text sizes",
    shortcut: "",
    keywords: ["settings", "font", "heading", "size"],
  },
  {
    id: "ai-settings",
    key: "AI",
    label: "AI settings…",
    detail: "Gateway key, model, and thinking",
    shortcut: "",
    keywords: ["settings", "assistant", "vercel", "gateway", "api key", "model", "reasoning", "effort"],
  },
  {
    id: "markdown-help",
    key: "HELP",
    label: "Markdown help",
    detail: "Open formatting guide",
    shortcut: "F1",
    keywords: ["syntax", "format", "reference"],
  },
  {
    id: "focus-library",
    key: "LIB",
    label: "Go to the Library",
    detail: "Put the cursor in the sidebar, or back in the note",
    shortcut: "⌘⇧L",
    keywords: ["sidebar", "focus", "tree", "files"],
  },
  {
    id: "keyboard-shortcuts",
    key: "KEYS",
    label: "Keyboard shortcuts",
    detail: "Every key TurboNotes answers to",
    shortcut: "?",
    keywords: ["help", "hotkeys", "keybindings", "keys"],
  },
  {
    id: "open-guide",
    key: "GUIDE",
    label: "Open Guide.md",
    detail: "Read the built-in editor guide",
    shortcut: "",
    keywords: ["help", "documentation", "features", "manual"],
  },
] as const;

export type AppCommandId = (typeof APP_COMMANDS)[number]["id"];
export type AppCommand = (typeof APP_COMMANDS)[number];

export function filterAppCommands(query: string): readonly AppCommand[] {
  const terms = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return APP_COMMANDS;
  return APP_COMMANDS.filter((command) => {
    const haystack = [
      command.key,
      command.label,
      command.detail,
      command.shortcut,
      ...command.keywords,
    ]
      .join(" ")
      .toLocaleLowerCase();
    return terms.every((term) => haystack.includes(term));
  });
}
